import { Button, Divider, Flex, Tag, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRotate, faEnvelopeOpenDollar, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { centsToDollarsDisplay } from '../../displayFormatters'

type Props = {
  selectedCount: number
  selectedTotalCents: number
  totalAvailable: number
  isTenantConnectedToQuickBooks: boolean
  isSelectAllLoading: boolean
  sendDisabledTooltip?: string
  deleteDisabledTooltip?: string
  onSelectAll: () => void
  onClear: () => void
  onDelete: () => void
  onSync: () => void
  onSend: () => void
}

const BulkActionBar = ({
  selectedCount,
  selectedTotalCents,
  totalAvailable,
  isTenantConnectedToQuickBooks,
  isSelectAllLoading,
  sendDisabledTooltip,
  deleteDisabledTooltip,
  onSelectAll,
  onClear,
  onDelete,
  onSync,
  onSend,
}: Props) => {
  if (selectedCount === 0) {
    return null
  }

  return (
    <Flex
      align="center"
      gap={12}
      style={{
        backgroundColor: '#e6f4ff',
        border: '1px solid #91caff',
        borderRadius: 6,
        padding: '8px 16px',
      }}
    >
      <Tag color="processing" style={{ margin: 0 }}>{selectedCount}</Tag>
      <span>selected</span>

      <Divider type="vertical" />

      <Button type="link" style={{ padding: 0 }} onClick={onSelectAll} loading={isSelectAllLoading}>
        Select all {totalAvailable} invoices
      </Button>
      <Button type="link" style={{ padding: 0 }} onClick={onClear}>
        Clear Selection
      </Button>

      <Divider type="vertical" />

      <strong>Total:</strong>
      <span>{centsToDollarsDisplay(selectedTotalCents)}</span>

      <Flex gap={8} style={{ marginLeft: 'auto' }}>
        <Tooltip title={deleteDisabledTooltip}>
          <Button danger icon={<FontAwesomeIcon icon={faTrash} />} onClick={onDelete} disabled={deleteDisabledTooltip !== undefined}>
            Delete
          </Button>
        </Tooltip>
        {isTenantConnectedToQuickBooks && (
          <Button icon={<FontAwesomeIcon icon={faArrowsRotate} />} onClick={onSync}>
            Sync to QuickBooks
          </Button>
        )}
        <Tooltip title={sendDisabledTooltip}>
          <Button type="primary" icon={<FontAwesomeIcon icon={faEnvelopeOpenDollar} />} onClick={onSend} disabled={sendDisabledTooltip !== undefined}>
            Send
          </Button>
        </Tooltip>
      </Flex>
    </Flex>
  )
}

export default BulkActionBar
